export const selectCreateCampaigns = {
  all_object: (state) => state.createNewCompany,
};
